import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=13ec0df9&scoped=true"
import script from "./registerForm.vue?vue&type=script&lang=js"
export * from "./registerForm.vue?vue&type=script&lang=js"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=13ec0df9&prod&lang=less&scoped=true"
import style1 from "./registerForm.vue?vue&type=style&index=1&id=13ec0df9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec0df9",
  null
  
)

export default component.exports